import { HelpService } from '../../services/help.service';
import { FileService } from '../../services/file.service';
import { Slide } from 'shared';
import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, OnInit, PLATFORM_ID, ElementRef, ViewChild } from '@angular/core';
import { NbThemeService } from '@nebular/theme';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  @ViewChild('socialFeed') socialFeed: ElementRef;

  isBrowser = true;
  slides: Slide[] = [];
  instagramPosts = [];

  constructor(
    public helpService: HelpService,
    public themeService: NbThemeService,
    private fileService: FileService,
    @Inject(PLATFORM_ID) private platformId: any
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  async ngOnInit(): Promise<void> {
    if (this.isBrowser) {
      const config = JSON.parse((await this.helpService.getRemoteConfigData('slides')) || '{}');
      if (config['home'] && config['home'].length > 0) {
        this.slides = config['home'];
      } else {
        this.slides.push({
          templateName: 'missing',
          filePath: '',
          src: 'assets/images/missing_photo.jpg'
        });
      }
      this.slides.forEach((s) => {
        const res = document.createElement('link');
        res.rel = 'preload';
        res.as = 'image';
        res.href = s.src;
        document.head.appendChild(res);
      });
      this.instagramPosts = await this.fileService.getInstagramPosts();
    }
  }
}
